import React from "react";
import "./FaceTracker.scss";

export default function FaceTracker({ color, top, right, width, height, showTimer, count }) {
  return (
    <div
      className="tracker-box"
      style={{
        top: top,
        right: right,
        width: width,
        height: height,
        backgroundImage: `linear-gradient(to right, ${color} 4px, transparent 4px),
                          linear-gradient(to right, ${color} 4px, transparent 4px),
                          linear-gradient(to left, ${color} 4px, transparent 4px),
                          linear-gradient(to left, ${color} 4px, transparent 4px),
                          linear-gradient(${color} 4px, transparent 4px),
                          linear-gradient(${color} 4px, transparent 4px),
                          linear-gradient(to top, ${color} 4px, transparent 4px),
                          linear-gradient(to top, ${color} 4px, transparent 4px)`,
      }}
    >
      {showTimer ?
        <span className="timer-box">{count}</span>
        : null
      }
    </div>
  );
}
